import Axios from "axios";
import _ from "lodash";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getTasks(params, taskModule) {
        return Axios.get(
            `${baseURL}schedule/tasks/${taskModule}/${params.id}`,
            {
                params
            }
        ).then(response => response.data.response);
    },
    getScheduleTasks(params) {
        return Axios.get(`${baseURL}schedule/tasks`, {
            params
        }).then(response => response.data.response);
    },
    getTask(taskId, signal) {
        return Axios.get(`${baseURL}schedule/task/${taskId}`, {
            signal
        }).then(response => response.data.response);
    },
    removeTask(taskId, applyTo) {
        return Axios.delete(`${baseURLci}schedule/task/remove`, {
            params: { id: taskId, apply_to: applyTo }
        }).then(response => response.data);
    },
    createTask(params) {
        return Axios.post(`${baseURL}schedule/task`, params).then(
            response => response.data.response
        );
    },
    updateStatus(params) {
        let formData = new FormData();

        _.forEach(params, function (value, key) {
            formData.append(key, value);
        });

        return Axios.post(
            `${baseURL}schedule/task/${params.id}/update-status`,
            formData
        ).then(response => response.data.response);
    },
    async updateTask(params) {
        let formData = new FormData();

        await _.forEach(params, function (value, key) {
            formData.append(key, value);
        });

        return Axios.put(`${baseURL}schedule/task/${params.id}`, params).then(
            response => response.data.response
        );
    },
    bulkUpdateStatus(params) {
        return Axios.post(
            `${baseURL}schedule/task/bulk-update-status`,
            params
        ).then(response => response.data.response);
    },
    bulkDelete(params) {
        return Axios.delete(`${baseURL}schedule/task/bulk-delete`, {
            data: params
        }).then(response => response.data.response);
    }
};
